<div
  class="palantir-table-status"
  [style]="{
    color: status,
    background: status + '1A',
  }"
>
  <div class="palantir-table-status__circle" [style]="{ background: status }"></div>

  <palantir-text type="title" size="xs" [style]="{ color: status }" truncate="true">
    {{ label }}
  </palantir-text>
</div>
